import React, { useState } from "react";
import { useSelector } from "react-redux";
import style from "./measurementSidebar.module.scss";
import { ZoomPhoto } from "../Photos";
import { InfoBanner } from "../../../secondary/ReadOnlyBanner/InfoBanner";

export const MeasurementSidebar = () => {
  const [woundImageLoading, setWoundImageLoading] = useState(true);

  const assessmentDetail = useSelector((state) => state.patient.detailAssessment);
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };

  return (
    <div className="col-4">
      {measurementData?.status === "success" && <InfoBanner message={"Image measured successfully"} />}
      <div className={`${style.patient_wound}`}>
        <ZoomPhoto
          image={measurementData?.assessedImageSASURL || measurementData?.intialImageSASURL}
          loading={woundImageLoading}
          setLoading={setWoundImageLoading}
          showBottomBtn={false}
          classes={{
            outerClass: undefined,
            innerClass: "position-relative w-100",
            shimmerClass: style.image_skeleton,
          }}
          showTopBtn={assessmentDetail?.isWoundWithoutPhoto === 0}
        />
      </div>
    </div>
  );
};
